/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_contributors_title17 = /** @type {(inputs: {}) => string} */ () => {
	return `with`
};

const fr_contributors_title17 = /** @type {(inputs: {}) => string} */ () => {
	return `avec`
};

const de_contributors_title17 = /** @type {(inputs: {}) => string} */ () => {
	return `Mitwirkende`
};

const es_contributors_title17 = /** @type {(inputs: {}) => string} */ () => {
	return `con`
};

const it_contributors_title17 = /** @type {(inputs: {}) => string} */ () => {
	return `con`
};

const ar_contributors_title17 = /** @type {(inputs: {}) => string} */ () => {
	return `المساهمون`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const contributors_title17 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contributors_title17(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("contributors_title17", locale)
	if (locale === "en") return en_contributors_title17(inputs)
	if (locale === "fr") return fr_contributors_title17(inputs)
	if (locale === "de") return de_contributors_title17(inputs)
	if (locale === "es") return es_contributors_title17(inputs)
	if (locale === "it") return it_contributors_title17(inputs)
	return ar_contributors_title17(inputs)
};
export { contributors_title17 as "CONTRIBUTORS_TITLE" }